export default __webpack_public_path__ + "static/media/nodata.b676d47b.png";